import { render, staticRenderFns } from "./TerminologyListing.vue?vue&type=template&id=38e7f7ea&scoped=true"
import script from "./TerminologyListing.vue?vue&type=script&lang=js"
export * from "./TerminologyListing.vue?vue&type=script&lang=js"
import style0 from "./TerminologyListing.vue?vue&type=style&index=0&id=38e7f7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e7f7ea",
  null
  
)

export default component.exports